let cachedDomains: Set<string> | null = null;
let cacheTimestamp = 0;
const CACHE_TTL = 1000 * 60 * 60; // 1 hour

const LIST_URL =
  "https://raw.githubusercontent.com/disposable/disposable-email-domains/master/domains.txt";

export async function fetchDisposableDomains(): Promise<Set<string>> {
  if (cachedDomains && Date.now() - cacheTimestamp < CACHE_TTL) {
    return cachedDomains;
  }

  try {
    const res = await fetch(LIST_URL);
    if (!res.ok) throw new Error("Failed to fetch disposable domains");
    const text = await res.text();
    cachedDomains = new Set(
      text
        .split("\n")
        .map((d) => d.trim().toLowerCase())
        .filter(Boolean)
    );
    cacheTimestamp = Date.now();
    return cachedDomains;
  } catch (err) {
    console.error("Could not load disposable email list:", err);
    // Return cached version if available, otherwise empty set (fail open)
    return cachedDomains ?? new Set();
  }
}

export async function isDisposableEmail(email: string): Promise<boolean> {
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  const domains = await fetchDisposableDomains();
  return domains.has(domain);
}
